import React from 'react';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { StylesTable } from '../../Stylestable';
import { WarningModal } from '../../modals';
import Button from '@mui/material/Button';
import { ISupportQuest } from '../../../store/support/types';
import { DeleteSupportQuest, UpdateQuestPositions } from '../../../store/support/actions';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import { EditSupportQuest } from './EditQuestion';
import { useDraggAndDrop } from '../../../hooks/useDraggAndDrop';

interface Column {
  id: 'id' | 'name' | 'approved' | 'delete' | 'edit' | 'questions';
  label: string;
  align?: 'right' | 'left' | 'center';
  width?: string;
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: 'id', label: '№', align: 'center', width: '5%' },
  { id: 'name', label: 'Назва', align: 'left' },
  { id: 'approved', label: 'Публікація', align: 'center', width: '10%' },
  {
    id: 'edit',
    label: 'Редагувати',
    align: 'center',
    width: '9%',
  },
  {
    id: 'delete',
    label: 'Видалити',
    align: 'center',
    width: '9%',
  },
];

type PropsType = {
  listQuestion: ISupportQuest[];
  subpartId: number;
  handleCancel: () => void;
  supportSubPosition: number
};

export const ListQuestion: React.FC<PropsType> = ({ listQuestion, subpartId, handleCancel, supportSubPosition }) => {
  const [editData, setEditData] = React.useState<{ type: 'edit' | 'new'; data?: ISupportQuest | null; position: number } | null>(null);
  const [isModal, setIsModal] = React.useState<{ id: number, name: string } | null>(null);

  const dispatch = useDispatch();
  const classesTable = StylesTable();

  const { setCurrent, list } = useDraggAndDrop({
    data: listQuestion,
    callback: (data) => {
      dispatch(
        UpdateQuestPositions.request({
          data: {
            subpartId,
            positions: data,
          },
        })
      );
    },
  });

  const handleRemove = (id: number) => {
    dispatch(
      DeleteSupportQuest.request({
        id,
      })
    );
  };

  if (editData) {
    return (
      <EditSupportQuest
        subpartId={subpartId}
        type={editData.type}
        data={editData.data}
        position={editData.position}
        handleCancel={() => setEditData(null)}
      />
    );
  }

  return (
    <>
      <Box>
        <Button
          style={{ margin: '0 20px 10px 7px' }}
          variant="contained"
          color="primary"
          onClick={() => setEditData({ type: 'new', position: listQuestion.length || 0 })}
        >
          Створити питання
        </Button>
        <Button style={{ margin: '0 20px 10px 7px' }} variant="outlined" color="primary" onClick={handleCancel}>
          Повернутися
        </Button>
      </Box>
      <TableContainer className={classesTable.container}>
        <Table className={classesTable.table} stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ width: column?.width || '' }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {list?.map((row, i) => {
              return (
                <TableRow
                  data-position={i}
                  draggable
                  ref={(e) => setCurrent(e, i)}
                  style={{ maxHeight: 50, cursor: 'move' }}
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={`${i}-${row.id}`}
                >
                  <TableCell align="center">{`${supportSubPosition}.${i + 1}`}</TableCell>
                  <TableCell className={classesTable.row}>{row.name}</TableCell>
                  <TableCell align="center" className={classesTable.row}>
                    {row.approved ? <DoneIcon /> : ''}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton aria-label="edit" onClick={() => setEditData({ type: 'edit', data: row, position: row.position })}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    <IconButton aria-label="delete" onClick={() => setIsModal({ id: row.id, name: row.name })}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {isModal ? (
        <WarningModal
          handleApprove={(isApprove) => {
            isApprove && handleRemove(isModal.id);
            setIsModal(null);
          }}
          value={`підрозділ "${isModal.name}"`}
          open={!!isModal}
        />
      ) : null}
    </>
  );
};
